/** @jsxImportSource @emotion/react */

import React from 'react';
import styled from 'styled-components';
import Scroll from '@component/common/scroll';
import Line from '@component/common/line';
import * as size from '@constant/size';
import * as color from '@constant/color';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import { useCheckApplicationMetadata } from '@hook/common/useApplication';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: ${size.PAGE_PADDING};
`;

const MyPageKey = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  //justify-content: space-between;
  justify-content: flex-start;
  gap: 10px;
  align-items: end;
  width: 100%;
  height: 20px;
`;

const MyPageValue = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 20px;
`;

const ApplicationMetadataContentContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding: ${size.MARGIN_1} 0;
`;

const ITEM_TEXT_DESIGN = {
  text: { size: 'medium', bold: true },
  box: { width: '100%', alignX: 'left', margin: `0 0 5px 0` },
} as const;
const KEY_TEXT_DESIGN = { text: { size: 'medium', bold: false } } as const;
const VALUE_TEXT_DESIGN = { text: { size: 'medium', height: '25px', color: color.GRAY_1 } } as const;

const ApplicationMetadata = () => {
  // 화면 진입 시 앱에 메타데이터를 요청한다. 응답 전이거나 무응답이면 '-'가 유지된다.
  const { platform, version } = useCheckApplicationMetadata();

  const formatPlatform = (platform: string) => {
    const lower = platform.toLowerCase();
    if (lower === 'ios') return 'iOS';
    if (lower === 'android') return 'Android';
    if (lower === 'web') return 'Web';
    return platform;
  };

  return (
    <Wrapper>
      <Scroll direction='y' height={`calc(100%)`}>
        <TextBlock text='앱 정보' design={ITEM_TEXT_DESIGN} />
        <Line color={color.GRAY_2} />
        <ApplicationMetadataContentContainer>
          <MyPageKey>
            <TextBlock text='플랫폼' design={KEY_TEXT_DESIGN} />
          </MyPageKey>
          <MyPageValue>
            <TextBlock text={formatPlatform(platform)} design={VALUE_TEXT_DESIGN} />
          </MyPageValue>
          <Gap height={size.MARGIN_1} />
          <MyPageKey>
            <TextBlock text='버전' design={KEY_TEXT_DESIGN} />
          </MyPageKey>
          <MyPageValue>
            <TextBlock text={version} design={VALUE_TEXT_DESIGN} />
          </MyPageValue>
        </ApplicationMetadataContentContainer>
        <Line color={color.GRAY_3} />
      </Scroll>
    </Wrapper>
  );
};

export default ApplicationMetadata;
